import { SPORT_ICON_VARIANT, type SportIconVariant } from '../types/enums';

const SPORT_ICON_FOLDER_BY_VARIANT: Record<SportIconVariant, string> = {
  [SPORT_ICON_VARIANT.COLOR]: 'color',
  [SPORT_ICON_VARIANT.FLAT]: 'flat',
  [SPORT_ICON_VARIANT.MULTICOLOR]: 'multicolor',
  [SPORT_ICON_VARIANT.NEOBET]: 'neobet',
  [SPORT_ICON_VARIANT.SIMPLE]: 'simple',
};

const SPORT_ICON_EXTENSION_BY_VARIANT: Record<SportIconVariant, string> = {
  [SPORT_ICON_VARIANT.COLOR]: 'webp',
  [SPORT_ICON_VARIANT.FLAT]: 'svg',
  [SPORT_ICON_VARIANT.MULTICOLOR]: 'svg',
  [SPORT_ICON_VARIANT.NEOBET]: 'svg',
  [SPORT_ICON_VARIANT.SIMPLE]: 'svg',
};

export const DEFAULT_SPORT_ICON_VARIANT = SPORT_ICON_VARIANT.MULTICOLOR;

const SPORT_ICON_MASK_VARIANTS = new Set<SportIconVariant>([
  SPORT_ICON_VARIANT.FLAT,
  SPORT_ICON_VARIANT.NEOBET,
  SPORT_ICON_VARIANT.SIMPLE,
]);

export const getResolvedSportIconVariant = (variant: SportIconVariant = DEFAULT_SPORT_ICON_VARIANT) =>
  SPORT_ICON_FOLDER_BY_VARIANT[variant] ? variant : DEFAULT_SPORT_ICON_VARIANT;

export const getSportIconFolder = (variant: SportIconVariant = DEFAULT_SPORT_ICON_VARIANT) =>
  SPORT_ICON_FOLDER_BY_VARIANT[getResolvedSportIconVariant(variant)];

export const getSportIconExtension = (variant: SportIconVariant = DEFAULT_SPORT_ICON_VARIANT) =>
  SPORT_ICON_EXTENSION_BY_VARIANT[getResolvedSportIconVariant(variant)];

export const usesSportIconMask = (variant: SportIconVariant = DEFAULT_SPORT_ICON_VARIANT) =>
  SPORT_ICON_MASK_VARIANTS.has(getResolvedSportIconVariant(variant));

export const getSportIconUrl = ({
  minioBaseUrl,
  name,
  variant = DEFAULT_SPORT_ICON_VARIANT,
}: {
  minioBaseUrl: string;
  name: string;
  variant?: SportIconVariant;
}) => {
  const encodedName = encodeURIComponent(name.trim());

  return `${minioBaseUrl}/resources/icons/sports/${getSportIconFolder(variant)}/${encodedName}.${getSportIconExtension(variant)}`;
};
